export const ENVIRONMENTS = {
  test: 'test',
  preprod: 'preprod',
  prod: 'prod',
}

export const LANGUAGES = {
  ru: 'ru',
  kz: 'kz',
  ar: 'ar',
  en: 'en',
}

export const STORES = {
  ru: 'ru',
  kz: 'kz',
  ae: 'ae',
  qa: 'qa',
  sa: 'sa',
}

export const CONTURS = {
  cis: 'cis',
  me: 'me',
}

export const CONTURS_API_TIMEOUT = {
  [CONTURS.cis]: 30000, // 30 сек
  [CONTURS.me]: 60000, // 1 мин
}

const ELF_MODEL_PATH = {
  test: 'images/elf/Elf.glb',
  preprod: 'images/elf/preprod-Elf.glb',
  prod: 'images/elf/Elf.glb',
}

const CDN_URLS = {
  test: 'https://ru-msk-2.store.cloud.mts.ru/test-tamagotchi',
  prod_cis: 'https://tcdn.goldapple.ru',
  prod_me: 'https://tcdn.goldappleme.com',
}

const TAMAGOTCHI_URLS = {
  [STORES.ru]: {
    [ENVIRONMENTS.test]: 'https://test-tamagotchi.goldapple.ru',
    [ENVIRONMENTS.preprod]: 'https://preprod-tamagotchi.goldapple.ru',
    [ENVIRONMENTS.prod]: 'https://tamagotchi.goldapple.ru',
  },
  [STORES.kz]: {
    [ENVIRONMENTS.test]: 'https://test-tamagotchi-kz.goldapple.kz',
    [ENVIRONMENTS.preprod]: 'https://preprod-tamagotchi.goldapple.kz',
    [ENVIRONMENTS.prod]: 'https://tamagotchi.goldapple.kz',
  },
  [STORES.ae]: {
    [ENVIRONMENTS.test]: 'https://test-tamagotchi-ae.goldapple.ae',
    [ENVIRONMENTS.preprod]: 'https://preprod-tamagotchi.goldapple.ae',
    [ENVIRONMENTS.prod]: 'https://tamagotchi.goldapple.ae',
  },
  [STORES.qa]: {
    [ENVIRONMENTS.test]: 'https://test-tamagotchi-ae.goldapple.ae',
    [ENVIRONMENTS.preprod]: 'https://preprod-tamagotchi.goldapple.ae',
    [ENVIRONMENTS.prod]: 'https://tamagotchi.goldapple.qa',
  },
  [STORES.sa]: {
    [ENVIRONMENTS.test]: 'https://test-tamagotchi-ae.goldapple.ae',
    [ENVIRONMENTS.preprod]: 'https://preprod-tamagotchi.goldapple.ae',
    [ENVIRONMENTS.prod]: 'https://tamagotchi.goldapple.sa',
  },
}

export const CONFIG = {
  [STORES.ru]: {
    prod: {
      store: STORES.ru,
      env: ENVIRONMENTS.prod,
      cdn: CDN_URLS.prod_cis,
      elfModelPath: ELF_MODEL_PATH.prod,
      tamagotchiUrl: TAMAGOTCHI_URLS[STORES.ru][ENVIRONMENTS.prod],
    },
    preprod: {
      store: STORES.ru,
      env: ENVIRONMENTS.preprod,
      cdn: CDN_URLS.prod_cis,
      elfModelPath: ELF_MODEL_PATH.preprod,
      tamagotchiUrl: TAMAGOTCHI_URLS[STORES.ru][ENVIRONMENTS.preprod],
    },
    test: {
      store: STORES.ru,
      env: ENVIRONMENTS.test,
      cdn: CDN_URLS.test,
      elfModelPath: ELF_MODEL_PATH.test,
      tamagotchiUrl: TAMAGOTCHI_URLS[STORES.ru][ENVIRONMENTS.test],
    },
  },
  [STORES.kz]: {
    prod: {
      store: STORES.kz,
      env: ENVIRONMENTS.prod,
      cdn: CDN_URLS.prod_cis,
      elfModelPath: ELF_MODEL_PATH.prod,
      tamagotchiUrl: TAMAGOTCHI_URLS[STORES.kz][ENVIRONMENTS.prod],
    },
    preprod: {
      store: STORES.kz,
      env: ENVIRONMENTS.preprod,
      cdn: CDN_URLS.prod_cis,
      elfModelPath: ELF_MODEL_PATH.preprod,
      tamagotchiUrl: TAMAGOTCHI_URLS[STORES.kz][ENVIRONMENTS.preprod],
    },
    test: {
      store: STORES.kz,
      env: ENVIRONMENTS.test,
      cdn: CDN_URLS.test,
      elfModelPath: ELF_MODEL_PATH.test,
      tamagotchiUrl: TAMAGOTCHI_URLS[STORES.kz][ENVIRONMENTS.test],
    },
  },
  [STORES.ae]: {
    prod: {
      store: STORES.ae,
      env: ENVIRONMENTS.prod,
      cdn: CDN_URLS.prod_me,
      elfModelPath: ELF_MODEL_PATH.prod,
      tamagotchiUrl: TAMAGOTCHI_URLS[STORES.ae][ENVIRONMENTS.prod],
    },
    preprod: {
      store: STORES.ae,
      env: ENVIRONMENTS.preprod,
      cdn: CDN_URLS.prod_me,
      elfModelPath: ELF_MODEL_PATH.preprod,
      tamagotchiUrl: TAMAGOTCHI_URLS[STORES.ae][ENVIRONMENTS.preprod],
    },
    test: {
      store: STORES.ae,
      env: ENVIRONMENTS.test,
      cdn: CDN_URLS.test,
      elfModelPath: ELF_MODEL_PATH.test,
      tamagotchiUrl: TAMAGOTCHI_URLS[STORES.ae][ENVIRONMENTS.test],
    },
  },
  [STORES.qa]: {
    prod: {
      store: STORES.qa,
      env: ENVIRONMENTS.prod,
      cdn: CDN_URLS.prod_me,
      elfModelPath: ELF_MODEL_PATH.prod,
      tamagotchiUrl: TAMAGOTCHI_URLS[STORES.qa][ENVIRONMENTS.prod],
    },
    preprod: {
      store: STORES.qa,
      env: ENVIRONMENTS.preprod,
      cdn: CDN_URLS.prod_me,
      elfModelPath: ELF_MODEL_PATH.preprod,
      tamagotchiUrl: TAMAGOTCHI_URLS[STORES.qa][ENVIRONMENTS.preprod],
    },
    test: {
      store: STORES.qa,
      env: ENVIRONMENTS.test,
      cdn: CDN_URLS.test,
      elfModelPath: ELF_MODEL_PATH.test,
      tamagotchiUrl: TAMAGOTCHI_URLS[STORES.qa][ENVIRONMENTS.test],
    },
  },
  [STORES.sa]: {
    prod: {
      store: STORES.sa,
      env: ENVIRONMENTS.prod,
      cdn: CDN_URLS.prod_me,
      elfModelPath: ELF_MODEL_PATH.prod,
      tamagotchiUrl: TAMAGOTCHI_URLS[STORES.sa][ENVIRONMENTS.prod],
    },
    preprod: {
      store: STORES.sa,
      env: ENVIRONMENTS.preprod,
      cdn: CDN_URLS.prod_me,
      elfModelPath: ELF_MODEL_PATH.preprod,
      tamagotchiUrl: TAMAGOTCHI_URLS[STORES.sa][ENVIRONMENTS.preprod],
    },
    test: {
      store: STORES.sa,
      env: ENVIRONMENTS.test,
      cdn: CDN_URLS.test,
      elfModelPath: ELF_MODEL_PATH.test,
      tamagotchiUrl: TAMAGOTCHI_URLS[STORES.sa][ENVIRONMENTS.test],
    },
  },
}

export const defaultStore = process.env.DEFAULT_LANGUAGE || STORES.ru
export const defaultLanguages = process.env.DEFAULT_LANGUAGE || LANGUAGES.ru
